module.exports = __webpack_public_path__ + "img/shipo-menu-barge-performance.f6b29b23.svg";